import axios from "axios";

const state = {
  isActive: false,
  isActiveEditQuestion: false,
  isActivePoserQuestion: false,
  isActiveReplyQuestion: false,
  intituleEditQuestion: "",
  idEditQuestion: "",
  idMeetingEditQuestion: "",

  responseQuestionText: "",
  responseQuestionMedia: null,
  responseQuestionFile: null,
  responseQuestionId: null
};

const mutations = {
  POPUP_TOGGLE(state, payload) {
    state.isActive = !state.isActive;
  },
  POPUP_EDIT_QUESTION_TOGGLE(state, payload) {
    state.isActiveEditQuestion = !state.isActiveEditQuestion;
  },
  POPUP_POSER_QUESTION_TOGGLE(state, payload) {
    state.isActivePoserQuestion = !state.isActivePoserQuestion;
  },
  POPUP_REPLY_QUESTION_TOGGLE(state, payload) {
    state.isActiveReplyQuestion = !state.isActiveReplyQuestion;
  },
  HYDRATE_INTITULE_EDIT_QUESTION(state, payload) {
    state.intituleEditQuestion = payload;
  },
  HYDRATE_ID_EDIT_QUESTION(state, payload) {
    state.idEditQuestion = payload;
  },
  HYDRATE_ID_MEETING_EDIT_QUESTION(state, payload) {
    state.idMeetingEditQuestion = payload;
  },
  HYDRATE_RESPONSE_QUESTION(state, payload) {
    state.responseQuestionText = payload.response;
    state.responseQuestionMedia = payload.media;
    state.responseQuestionFile = payload.file;
    state.responseQuestionId = payload.id;
  },
  HYDRATE_RESPONSE_INTITULE_QUESTION(state, payload) {
    state.responseQuestionText = payload;
  }
};

const actions = {
  popupToggle({ commit }) {
    commit("POPUP_TOGGLE");
  },
  popupToggleEditQuestion({ commit }) {
    commit("POPUP_EDIT_QUESTION_TOGGLE");
  },
  popupTogglePoserQuestion({ commit }) {
    commit("POPUP_POSER_QUESTION_TOGGLE");
  },
  popupToggleReplyQuestion({ commit }) {
    commit("POPUP_REPLY_QUESTION_TOGGLE");
  },
  HydrateEditQuestion({ commit }, question) {
    commit("HYDRATE_INTITULE_EDIT_QUESTION", question.question);
    commit("HYDRATE_ID_EDIT_QUESTION", question.id);
    commit("HYDRATE_ID_MEETING_EDIT_QUESTION", question.meeting_id);
    if (question.response) {
      commit("HYDRATE_RESPONSE_QUESTION", question.response);
    }
  },
  update_intitule_question({ commit }, url_moderateur) {
    var update_question_values = {
      question: this.getters.intituleEditQuestion
    };

    axios.defaults.headers.common["urlmoderateur"] = url_moderateur;
    axios
      .put(
        process.env.URL_SSO_API +
          "textit/public/meeting/" +
          this.getters.idMeetingEditQuestion +
          "/question/" +
          this.getters.idEditQuestion,
        update_question_values
      )
      .then(response => {
        //commit('UPDATE_MEETING_IN_LIST', response.data)
      })
      .catch(error => {
        console.log(error);
      });
  }
};

const getters = {
  isActive: state => state.isActive,
  idEditQuestion: state => state.idEditQuestion,
  intituleEditQuestion: state => state.intituleEditQuestion,
  idMeetingEditQuestion: state => state.idMeetingEditQuestion
};

const popupModule = {
  state,
  mutations,
  actions,
  getters
};

export default popupModule;



// WEBPACK FOOTER //
// ./src/store/modules/popup/index.js